import MonetaryUtils from "../../../shared/utils/MonetaryUtils";
import { hasValue } from "../../utils/pacto-rebates-utils";

const getNetSalesValue = values => {
	return values.netSalesGreaterThanOrEqual ?? values.netSalesGreaterOrEqual;
};

export const formatSegmentationPayload = ({
	segmentation,
	netSalesGreaterThanOrEqual,
	netSalesGreaterOrEqual
}) => {
	const netSalesValue = netSalesGreaterThanOrEqual ?? netSalesGreaterOrEqual;

	return {
		identificacao: String(segmentation || "").trim(),
		netSalesAlvo: MonetaryUtils.parseCurrency(netSalesValue)
	};
};

export const formatSegmentationResponse = segmentation => ({
	id: segmentation.id,
	segmentation: segmentation.identificacao,
	netSalesGreaterThanOrEqual: segmentation.netSalesAlvo,
	createdAt: segmentation.dataCriacao,
	updatedAt: segmentation.dataUltimaAtualizacao
});

const isValidNetSalesLength = value => {
	const onlyNumbers = String(value || "").replace(/\D/g, "");

	return onlyNumbers.length <= 15;
};

export const validateSegmentationPayload = values => {
	const errors = {};
	const netSalesValue = getNetSalesValue(values);
	const segmentationValue = String(values.segmentation || "").trim();

	if (!hasValue(segmentationValue)) {
		errors.segmentation = "Informe o tamanho do cliente.";
	} else if (segmentationValue.length > 2) {
		errors.segmentation = "O tamanho do cliente deve ter até 2 caracteres.";
	}

	if (!hasValue(netSalesValue)) {
		errors.netSalesGreaterOrEqual = "Informe o Net Sales maior ou igual a.";
	} else if (!isValidNetSalesLength(netSalesValue)) {
		errors.netSalesGreaterOrEqual = "O Net Sales deve ter no máximo 15 caracteres, sendo 2 decimais.";
	}

	return errors;
};

export const buildSegmentationOptions = segmentations => {
	return (segmentations || [])
		.filter(segmentation => segmentation?.id !== undefined && segmentation?.segmentation)
		.map(segmentation => ({
			label: segmentation.segmentation,
			value: String(segmentation.id)
		}));
};

export const formatSegmentationValue = value => {
	return String(value || "")
		.toUpperCase()
		.slice(0, 2);
};

export const formatSegmentationNetSalesValue = value => {
	const onlyNumbers = String(value || "")
		.replace(/\D/g, "")
		.slice(0, 15);

	if (!onlyNumbers) {
		return "";
	}

	return MonetaryUtils.formatCurrency(onlyNumbers, {
		fromCents: true
	});
};